import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'

import { EVENT_TYPE, STRING } from 'resources'
import { COPY_TO_CLIPBOARD_TIMEOUT_MS } from 'resources/constants'
import { APP_LINK, APP_URLS } from 'resources/urls'
import { socialBubbles } from 'resources/images'

import ScreenContainer from 'components/ScreenContainer'

import PrimaryLink from 'units/PrimaryLink'
import profileInfoActions from 'models/ProfileInfo/actions'
import { getBranchRedemptionLink } from 'models/ProfileInfo/selectors'
import { getRedemptionShareCaption } from 'models/General/selectors'
import { sendAnalyticsEvent } from 'services/analytics'

import RedeemSocialShareHeader from './RedeemSocialShareHeader'

import {
  RedemptionShareContainer,
  RedemptionSocialShareText,
  SocialBubbles,
  CopyButton,
  ShareButton,
  ReturnButton,
} from './styles'

const RedemptionSocialShare = () => {
  const dispatch = useDispatch()
  const history = useHistory()

  const branchRedemptionLink = useSelector(getBranchRedemptionLink)
  const redemptionShareCaption = useSelector(getRedemptionShareCaption)

  const [copySuccess, setCopySuccess] = useState(false)
  const [isFetched, setIsFetched] = useState(false)

  useEffect(() => {
    setIsFetched(false)
    dispatch(
      profileInfoActions.fetchProfileInfo.init(() => {
        setIsFetched(true)
      }),
    )
  }, [dispatch])

  useEffect(() => {
    if (isFetched && !branchRedemptionLink) {
      history.replace(APP_URLS.WALLET)
    }
  }, [isFetched, branchRedemptionLink, history])

  const textToShare = `${redemptionShareCaption} ${branchRedemptionLink}`

  const handleCopyLink = async () => {
    sendAnalyticsEvent(EVENT_TYPE.redemptionShareCopyLink)
    try {
      await navigator.clipboard.writeText(branchRedemptionLink)
      setCopySuccess(true)
      setTimeout(() => setCopySuccess(false), COPY_TO_CLIPBOARD_TIMEOUT_MS)
    } catch (err) {
      console.log('[Redemption Social Share] Failed to write branch redemption link to clipboard: ', err) // eslint-disable-line no-console
    }
  }

  const handleShareLink = async () => {
    sendAnalyticsEvent(EVENT_TYPE.redemptionShareMyLink)
    try {
      await navigator.share({ text: textToShare })
    } catch (err) {
      console.log('[Redemption Social Share] Failed to share branch redemption link: ', err) // eslint-disable-line no-console
    }
  }

  const handleReturnToApp = () => {
    sendAnalyticsEvent(EVENT_TYPE.redemptionShareReturnToApp)
  }

  const shareSheetEnabled =
    typeof window?.navigator?.canShare === 'function' && navigator.canShare({ text: textToShare })

  return (
    <>
      <RedeemSocialShareHeader />
      <ScreenContainer>
        <RedemptionShareContainer>
          <RedemptionSocialShareText>{STRING.wallet.redemptions.socialShare.shareText}</RedemptionSocialShareText>
          <SocialBubbles src={socialBubbles} />
          <CopyButton onClick={handleCopyLink}>
            {copySuccess
              ? STRING.wallet.redemptions.socialShare.copiedLink
              : STRING.wallet.redemptions.socialShare.copyLink}
          </CopyButton>
          {shareSheetEnabled && (
            <ShareButton onClick={handleShareLink}>{STRING.wallet.redemptions.socialShare.shareLink}</ShareButton>
          )}
          <ReturnButton to={APP_LINK} tag={PrimaryLink} onClick={handleReturnToApp}>
            {STRING.wallet.redemptions.socialShare.returnToApp}
          </ReturnButton>
        </RedemptionShareContainer>
      </ScreenContainer>
    </>
  )
}

export default RedemptionSocialShare
